import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';
import AppHeader from '../AppHeader/AppHeader';
import AppFooterContainer from '../AppFooter/AppFooterContainer';
import StackedNotifications from '../StackedNotifications/StackedNotifications';
import SignalRBootstrapper from '../Push/SignalRBootstrapper';
import './Page.css';

class Page extends PureComponent {
  render() {
    return (
      <div className={`page page-${this.props.pageName}`}>
        <AppHeader />
        <div className={`page__content page-${this.props.pageName}__content u-pa-full`}>
          {this.props.children}
        </div>
        <AppFooterContainer />
        <SnackbarProvider
          maxSnack={5}
          dense
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          <StackedNotifications />
        </SnackbarProvider>
        <SignalRBootstrapper />
      </div>
    );
  }
}

Page.propTypes = {
  pageName: PropTypes.string,
};

Page.defaultProps = {
  pageName: 'unknown',
};

export default Page;
